import { Divider } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import FirstStep from 'images/icons/icon_round_one_blue.svg'
import ThirdStep from 'images/icons/icon_round_three_blue.svg'
import SecondStep from 'images/icons/icon_round_two_blue.svg'
import CheckScores from 'images/icons/smp_check_scores.svg'
import FinancingConditions from 'images/icons/smp_financing.svg'
import Optimize from 'images/icons/smp_optimize_score.svg'
import React, { FC } from 'react'
import { scopedTranslation } from 'src/helpers'

import { IconItem } from '../IconItem/IconItem'
import { RegisterButton } from '../RegisterButton/RegisterButton'

const { t } = scopedTranslation('component.smp.landing_page.three_steps_section')

export const ThreeStepsSection: FC = () => (
  <Box maxWidth='97rem' m='auto'>
    <Grid container={ true } spacing={ 2 }>
      <Grid item={ true } xs={ 12 }>
        <Box my={ 5 } textAlign='center' mx='auto' maxWidth='85rem'>
          <Typography variant='h2'>{ t('headline') }</Typography>
        </Box>
      </Grid>
      <Grid item={ true } xs={ 12 } md={ 4 }>
        <IconItem
          iconSource={ CheckScores }
          itemText={ t('check_scores') }
        />
      </Grid>
      <Grid item={ true } xs={ 12 } md={ 4 }>
        <IconItem
          iconSource={ Optimize }
          itemText={ t('optimize_score') }
        />
      </Grid>
      <Grid item={ true } xs={ 12 } md={ 4 }>
        <IconItem
          iconSource={ FinancingConditions }
          itemText={ t('improve_financing_conditions') }
        />
      </Grid>
    </Grid>
    <Box my={ 6 } textAlign='center'>
      <Typography variant='h2'>{ t('steps_headline') }</Typography>
    </Box>
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      textAlign='center'
    >
      <Box mt={ 2 } mb={ 4 }>
        <img src={ FirstStep } alt={ t('first_step_alt_text') } height='48' />
      </Box>
      <Box my={ 1 }>
        <Typography variant='h2' color='textPrimary'>
          { t('first_step_headline') }
        </Typography>
      </Box>
      <Box mb={ 2 }>
        <Typography>
          { t('first_step_description') }
        </Typography>
      </Box>
      <Box my={ 1 } height='8rem' alignSelf='center'>
        <Divider orientation='vertical' />
      </Box>
      <Box mt={ 2 } mb={ 4 }>
        <img src={ SecondStep } alt={ t('second_step_alt_text') } height='48' />
      </Box>
      <Box my={ 1 }>
        <Typography variant='h2' color='textPrimary'>
          { t('second_step_headline') }
        </Typography>
      </Box>
      <Box mb={ 2 }>
        <Typography>
          { t('second_step_description') }
        </Typography>
      </Box>
      <Box my={ 1 } height='8rem' alignSelf='center'>
        <Divider orientation='vertical' />
      </Box>
      <Box mt={ 2 } mb={ 4 }>
        <img src={ ThirdStep } alt={ t('third_step_alt_text') } height='48' />
      </Box>
      <Box my={ 1 }>
        <Typography variant='h2' color='textPrimary'>
          { t('third_step_headline') }
        </Typography>
      </Box>
      <Box>
        <Typography>
          { t('third_step_description') }
        </Typography>
      </Box>
      <Box mt={ 9 } mb={ 18 }>
        <RegisterButton
          buttonKey='call-to-action-bottom'
          centered={ true }
        />
      </Box>
    </Box>
  </Box>
)
